export default __webpack_public_path__ + "static/media/plusIcon.5e065dca.svg";